/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function JournalVoucher9Info({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { rows = [], groupLabels = {}, totals = {} } = values;

  const groupKeys = ["211", "212", "213", "215", "217"];

  const handleChangeField = (path, val) => setFieldValue(path, val);

  const calculateSums = () => {
    // 1. Calculate row group totals
    const newRows = rows.map(row => {
      const updatedRow = { ...row };
      groupKeys.forEach(key => {
        const group = row[`group${key}`] || { values: [0, 0, 0, 0], total: 0 };
        const total = (group.values || []).reduce((acc, v) => acc + (parseFloat(v) || 0), 0);
        updatedRow[`group${key}`] = { ...group, total };
      });
      return updatedRow;
    });

    // 2. Calculate vertical totals
    const newTotals = {
      group211: { values: [0, 0, 0, 0], total: 0 },
      group212: { values: [0, 0, 0, 0], total: 0 },
      group213: { values: [0, 0, 0, 0], total: 0 },
      group215: { values: [0, 0, 0, 0], total: 0 },
      group217: { values: [0, 0, 0, 0], total: 0 },
    };

    newRows.forEach(r => {
      groupKeys.forEach(key => {
        const group = r[`group${key}`];
        group.values.forEach((v, i) => {
          newTotals[`group${key}`].values[i] += (parseFloat(v) || 0);
        });
        newTotals[`group${key}`].total += group.total || 0;
      });
    });

    if (JSON.stringify(newRows) !== JSON.stringify(rows)) setFieldValue("rows", newRows);
    if (JSON.stringify(newTotals) !== JSON.stringify(totals)) setFieldValue("totals", newTotals);
  };

  useEffect(() => {
    calculateSums();
  }, [JSON.stringify(rows.map(r => ({
    v211: r.group211?.values, v212: r.group212?.values, v213: r.group213?.values, v215: r.group215?.values, v217: r.group217?.values
  })))]);

  const addRow = () => setFieldValue("rows", [...rows, {
    index: rows.length + 1,
    docNumber: "",
    docDate: "",
    description: "",
    group211: { values: [0, 0, 0, 0], total: 0 },
    group212: { values: [0, 0, 0, 0], total: 0 },
    group213: { values: [0, 0, 0, 0], total: 0 },
    group215: { values: [0, 0, 0, 0], total: 0 },
    group217: { values: [0, 0, 0, 0], total: 0 },
  }]);

  const removeRow = (idx) => {
    if (rows.length <= 1) return;
    setFieldValue("rows", rows.filter((_, i) => i !== idx));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "12px", lineHeight: "1.3" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "12px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "12px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    th: { border: "1px solid #000", padding: "2px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f2f2f2" },
    td: { border: "1px solid #000", padding: 0, height: "28px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 2px", fontSize: "11px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "11px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 2px", fontSize: "11px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "14px" },
  };

  return (
    <SoftBox style={s.container}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <div style={{ width: "40%" }}>
          <div style={{ display: "flex", gap: 5 }}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={{ display: "flex", gap: 5, marginTop: 5 }}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "60%" }}>
          <div style={{ fontWeight: "bold", fontSize: "14px" }}>Mẫu số S04a9-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "10px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "16px" }}>NHẬT KÝ CHỨNG TỪ SỐ 9</h2>
        <div style={{ fontWeight: "bold", fontSize: "14px", marginTop: 5 }}>
          Ghi Có TK 211, 212, 213, 215, 217; Ghi Nợ các TK
        </div>
        <div style={{ marginTop: 10, fontWeight: "bold" }}>
          Tháng <input disabled={containView} style={{ ...s.inputDotted, width: "40px", textAlign: "center" }} value={values.month} onChange={(e) => handleChangeField("month", e.target.value)} />
          {" "}năm <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
      </div>

      <div style={{ overflowX: "auto", border: "1px solid #000" }}>
        <table style={{ borderCollapse: "collapse", minWidth: "2200px", width: "100%" }}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "40px" }} rowSpan={3}>Số TT</th>
              <th style={{ ...s.th, width: "150px" }} colSpan={2}>Chứng từ</th>
              <th style={{ ...s.th, width: "200px" }} rowSpan={3}>Diễn giải</th>
              {groupKeys.map(key => (
                <th key={key} style={s.th} colSpan={5}>Ghi Có TK {key}, ghi Nợ các TK</th>
              ))}
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={4}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "70px" }} rowSpan={2}>Số hiệu</th>
              <th style={{ ...s.th, width: "80px" }} rowSpan={2}>Ngày tháng</th>
              {groupKeys.map(key => (
                <React.Fragment key={key}>
                  {[...Array(4)].map((_, i) => (
                    <th key={i} style={{ ...s.th, width: "80px" }}>
                      <input 
                        disabled={containView} 
                        style={s.inputTableCenter} 
                        placeholder="..." 
                        value={groupLabels?.[`labels${key}`]?.[i] || ""} 
                        onChange={(e) => {
                          const newLabels = { ...groupLabels };
                          if (!newLabels[`labels${key}`]) newLabels[`labels${key}`] = ["", "", "", ""];
                          newLabels[`labels${key}`][i] = e.target.value;
                          setFieldValue("groupLabels", newLabels);
                        }}
                      />
                    </th>
                  ))}
                  <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Cộng Có TK {key}</th>
                </React.Fragment>
              ))}
            </tr>
            <tr>
              {/* This level contains subheadings for columns 1, 2, 3 ... if any */}
              {/* Since S04a9-DN doesn't have explicit subheadings under labels, we just fill numbers below */}
            </tr>
            <tr style={{ backgroundColor: "#eee" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              {/* Group numbers 1-5, 6-10 ... */}
              {groupKeys.map((_, gIdx) => (
                <React.Fragment key={gIdx}>
                  {[...Array(5)].map((_, i) => (
                    <th key={i} style={s.th}>{gIdx * 5 + i + 1}</th>
                  ))}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.index} onChange={(e) => handleChangeField(`rows.${idx}.index`, e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.docNumber} onChange={(e) => handleChangeField(`rows.${idx}.docNumber`, e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.docDate} onChange={(e) => handleChangeField(`rows.${idx}.docDate`, e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={row.description} onChange={(e) => handleChangeField(`rows.${idx}.description`, e.target.value)} /></td>
                {groupKeys.map(key => {
                  const gName = `group${key}`;
                  const group = row[gName] || { values: [0,0,0,0], total: 0 };
                  return (
                    <React.Fragment key={key}>
                      {[...Array(4)].map((_, i) => (
                        <td key={i} style={s.td}>
                          <input 
                            disabled={containView} 
                            type="number" 
                            style={s.inputTableRight} 
                            value={group.values[i]} 
                            onChange={(e) => handleChangeField(`rows.${idx}.${gName}.values.${i}`, e.target.value)} 
                          />
                        </td>
                      ))}
                      <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#f9f9f9", fontWeight: "bold" }}>{fmt(group.total)}</td>
                    </React.Fragment>
                  );
                })}
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>-</button></td>}
              </tr>
            ))}

            {/* TOTALS */}
            <tr style={{ backgroundColor: "#fafafa", fontWeight: "bold" }}>
              <td style={s.td} colSpan={4} align="center">Cộng</td>
              {groupKeys.map(key => {
                const gTotal = totals[`group${key}`] || { values: [0,0,0,0], total: 0 };
                return (
                  <React.Fragment key={key}>
                    {gTotal.values.map((v, i) => (
                      <td key={i} style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(v)}</td>
                    ))}
                    <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", backgroundColor: "#f0f0f0" }}>{fmt(gTotal.total)}</td>
                  </React.Fragment>
                );
              })}
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
      </div>

      {!containView && (
        <SoftBox textAlign="center" mt={2}>
          <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm dòng</SoftButton>
        </SoftBox>
      )}

      {/* FOOTER */}
      <div style={{ marginTop: "15px" }}>
          Đã ghi Sổ Cái ngày <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.recordedToLedgerDay} onChange={(e) => handleChangeField("recordedToLedgerDay", e.target.value)} />
          {" "} tháng <input disabled={containView} style={{ ...s.inputDotted, width: "30px", textAlign: "center" }} value={values.recordedToLedgerMonth} onChange={(e) => handleChangeField("recordedToLedgerMonth", e.target.value)} />
          {" "} năm <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.recordedToLedgerYear} onChange={(e) => handleChangeField("recordedToLedgerYear", e.target.value)} />
      </div>     
    </SoftBox>
  );
}
